// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Factoids__Wrapper_2Z3je","Factoid":"Factoids__Factoid_1rbL5","Name":"Factoids__Name_2Hf_a","Value":"Factoids__Value_3Q_2z"};